"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineChart = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const polished_1 = require("polished");
const group_1 = require("@visx/group");
const curve_1 = require("@visx/curve");
const shape_1 = require("@visx/shape");
const axis_1 = require("@visx/axis");
const scale_1 = require("@visx/scale");
const variants_1 = require("../../themes/variants");
const main_1 = require("../useTooltip/main");
function LineChart({ width, height, variant, data, colors, selectedLabel, onChange, yLabel, xLabel, curve = curve_1.curveLinear, tooltip = true, stackArea, margin = { top: 30, right: 30, bottom: 60, left: 60 }, }) {
    const theme = (0, styled_components_1.useTheme)();
    const chartTooltip = (0, main_1.useTooltip)();
    const [coordsLine, setCoordsLine] = (0, react_1.useState)();
    const svgRef = (0, react_1.createRef)();
    const primaryColor = (0, variants_1.variantTextColor)({ theme, variant });
    const bgColor = (0, variants_1.variantBgColor)({ theme, variant });
    const xMax = width - margin.left - margin.right;
    const yMax = height - margin.top - margin.bottom;
    if (!data || !data.length || width < 10)
        return null;
    const series = Object.keys(data[0].values);
    const ticks = data.map(({ serie }) => serie);
    const chartData = data.reduce((prev, curr) => {
        series.forEach((label) => {
            let dataItem = prev.data.find(({ serie }) => serie === label);
            if (!dataItem) {
                dataItem = { serie: label, values: {} };
                prev.data.push(dataItem);
            }
            Object.assign(dataItem.values, {
                [curr.serie]: curr.values[label],
            });
            return Object.assign(prev, {
                min: Math.min(prev.min, curr.values[label]),
                max: Math.max(prev.max, curr.values[label]),
            });
        });
        return prev;
    }, { data: [], min: 0, max: 0 });
    const { min, max } = chartData;
    data = chartData.data;
    if (stackArea) {
        data = data.sort((a, b) => {
            const avg = ticks.reduce((prev, curr) => {
                prev.a = Math.min(a.values[curr] || 0, prev.a);
                prev.b = Math.min(b.values[curr] || 0, prev.b);
                return prev;
            }, { a: 0, b: 0 });
            if (!avg)
                return 0;
            return avg.a > avg.b ? 1 : -1;
        });
    }
    const xScale = (0, scale_1.scaleBand)({
        domain: ticks,
        range: [0, xMax],
    });
    const xTicks = ticks.reduce((prev, curr) => {
        return Object.assign(prev, {
            [String(xScale(curr))]: curr,
        });
    }, {});
    function findClosestTick(x) {
        const tick = Object.keys(xTicks).sort((a, b) => {
            return Math.abs(x - parseInt(a)) <= Math.abs(x - parseInt(b)) ? -1 : 1;
        })[0];
        return xTicks[tick];
    }
    const yScale = (0, scale_1.scaleLinear)({
        domain: [min, max],
        range: [yMax, 0],
    });
    colors =
        colors ||
            (() => {
                const maxDiff = 0.3;
                const step = maxDiff / data.length;
                const colors = [];
                const start = (0, polished_1.lighten)(maxDiff / 2, primaryColor);
                let dark = 0;
                while (colors.length < data.length) {
                    colors.push((0, polished_1.darken)(dark, start));
                    dark = dark + step;
                }
                return colors;
            })();
    const colorScale = (0, scale_1.scaleOrdinal)({
        domain: data.map((item) => item.serie),
        range: colors,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", { width: width, height: height, ref: svgRef },
            react_1.default.createElement("rect", { width: width, height: height, fill: bgColor, rx: 14 }),
            react_1.default.createElement(axis_1.AxisLeft, { scale: yScale, stroke: primaryColor, tickStroke: primaryColor, left: margin.left, top: margin.top, tickLabelProps: () => ({
                    fill: primaryColor,
                    fontSize: 11,
                    textAnchor: "end",
                }), label: yLabel, labelProps: {
                    x: -(yMax / 2),
                    y: -40,
                    textAnchor: "middle",
                    fontSize: 14,
                    fontWeight: 800,
                    fill: primaryColor,
                } }),
            react_1.default.createElement(axis_1.AxisBottom, { top: yMax + margin.top, left: margin.left, scale: xScale, stroke: primaryColor, tickStroke: primaryColor, label: xLabel, labelProps: {
                    x: xMax / 2,
                    y: 40,
                    textAnchor: "middle",
                    fontSize: 14,
                    fontWeight: 800,
                    fill: primaryColor,
                }, tickLabelProps: () => ({
                    fill: primaryColor,
                    fontSize: 11,
                    textAnchor: "middle",
                }) }),
            coordsLine && (react_1.default.createElement("g", null,
                react_1.default.createElement(shape_1.Line, { from: {
                        y: margin.top,
                        x: coordsLine[0] + margin.left,
                    }, to: {
                        y: height - margin.bottom + 5,
                        x: coordsLine[0] + margin.left,
                    }, stroke: primaryColor, strokeWidth: 1, pointerEvents: "none", strokeDasharray: "5,2" }),
                react_1.default.createElement(shape_1.Line, { from: {
                        x: margin.left - 5,
                        y: coordsLine[1] + margin.top,
                    }, to: {
                        x: width - margin.right,
                        y: coordsLine[1] + margin.top,
                    }, stroke: primaryColor, strokeWidth: 1, pointerEvents: "none", strokeDasharray: "5,2" }),
                react_1.default.createElement("circle", { cx: coordsLine[0] + margin.left, cy: coordsLine[1] + margin.top, r: 4, fill: bgColor, stroke: primaryColor, strokeWidth: 2 }))),
            react_1.default.createElement(group_1.Group, { top: margin.top, left: margin.left, onMouseLeave: function handleMouseLeave() {
                    chartTooltip.hide();
                    setCoordsLine(undefined);
                }, onMouseMove: function handleMouseMove(e) {
                    var _a;
                    const { clientX, clientY } = e;
                    const rect = (_a = svgRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                    if (!rect)
                        return;
                    const coordsLine = [
                        clientX - rect.left - margin.left,
                        clientY - rect.top - margin.top,
                    ];
                    setCoordsLine(coordsLine);
                    const xTick = findClosestTick(coordsLine[0]);
                    tooltip &&
                        chartTooltip.positionSVGTooltip(e, svgRef.current, {
                            title: xTick,
                            values: data
                                .map((datum) => {
                                return {
                                    label: datum.serie,
                                    value: datum.values[xTick],
                                    color: colorScale(datum.serie),
                                };
                            })
                                .sort((a, b) => {
                                return a.value < b.value ? 1 : -1;
                            }),
                            renderer: tooltip,
                        });
                } },
                react_1.default.createElement("rect", { width: xMax, height: yMax, fill: "transparent" }),
                data.map((item) => {
                    const points = ticks.map((label, i) => {
                        const xVal = xScale(label) || 0;
                        const yVal = yScale(item.values[label]);
                        return {
                            x: xVal,
                            y: yVal,
                            label,
                        };
                    });
                    const stroke = colorScale(item.serie);
                    const fill = (0, polished_1.rgba)(stroke, selectedLabel === item.serie ? 0.85 : 0.4);
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(shape_1.LinePath, { curve: !stackArea ? curve : curve_1.curveLinear, key: `line-${item.serie}`, data: points, x: (d) => d.x, y: (d) => d.y, shapeRendering: "geometricPrecision", strokeLinecap: "round", fillOpacity: 0.3, stroke: stroke, strokeWidth: 2 }),
                        stackArea && (react_1.default.createElement(shape_1.LinePath, { curve: curve_1.curveLinear, key: `fill-${item.serie}`, data: points.concat([
                                { x: points[points.length - 1].x, y: yMax, label: "" },
                                { x: points[0].x, y: yMax, label: "" },
                                { x: points[0].x, y: points[0].y, label: "" },
                            ]), x: (d) => d.x, y: (d) => d.y, shapeRendering: "geometricPrecision", strokeLinecap: "round", fill: fill, fillOpacity: 0.3, strokeWidth: 2, onMouseLeave: function handleMouseLeave() {
                                onChange && onChange();
                            }, onMouseMove: function handleMouseMove(e) {
                                onChange &&
                                    selectedLabel !== item.serie &&
                                    onChange(item);
                            } }))));
                }))),
        chartTooltip.element));
}
exports.LineChart = LineChart;
//# sourceMappingURL=main.js.map